module.exports = __webpack_public_path__ + "img/official_pic.b5098e0c.jpg";